export { Body } from './Body'
export type { BodyProps } from './Body'

export { Mono } from './Mono'
export type { MonoProps } from './Mono'

export { Heading } from './Heading'
export type { HeadingProps } from './Heading'
